
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sender",
      function () {
        return require("private-next-pages/sender.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sender"])
      });
    }
  